import AjaxComponentLoader from 'utils/ajax_component_loader';
import FormSubmitToggle from 'utils/form_submit_toggle';
import ModalManager from 'utils/modal_manager';
import SignupEmailAssist from 'utils/signup_email_assist';
import validator from 'utils/validator';
import zaraz from 'utils/trackers/zaraz';

const credentials = {
  development: {
    client_id:
      '1c35da89e00bf86c161e668d6aa01f31e075ed3311db945df2680ba4b6a27255',
    client_secret:
      '023630cc8053a175aefc301d25198bb1fd0499fe9d8a931e3abe6dd82cabe20a'
  },
  staging: {
    client_id:
      '5c4a9f9fe4234cf6cd6967a0d83266c26a4ac25edd3d4176ad62dff9de8e1b81',
    client_secret:
      '60e88b34ee54d2ffd71d7d87af726ef8e10bdb8f9907e0eebade0c83d0c5b6b4'
  },
  production: {
    client_id:
      '2cd360dd07bc856dd68bbbd2976f7e1aa1bdee7b359be4d236d7b04c03ec1284',
    client_secret:
      '22977b636e45831cd02796645a32b95ea435c9a0532e176756bf665b6e6cbb4a'
  }
};

class LoginRegisterModal {
  email = null;

  constructor(container, newModal) {
    this.container = container;

    newModal ? this.initNew() : this.init();
  }

  init() {
    this.btnLogin = $('#button-login', this.container);
    this.btnRegister = $('#button-register', this.container);
    this.modalRegister = $('#modal-register', this.container);
    this.modalLogin = $('#modal-login', this.container);

    this.btnLogin.on('click', () => {
      this.modalRegister.hide();
      this.modalLogin.show();
    });

    this.btnRegister.on('click', () => {
      this.modalRegister.show();
      this.modalLogin.hide();
    });
  }

  initNew() {
    this.btnLogin = $('.button-login', this.container);
    this.btnLoginEmail = $('.button-login-email', this.container);
    this.btnRegisterEmail = $('.button-register-email', this.container);
    this.btnRegisterSocial = $('.button-register-social', this.container);
    this.btnRecovery = $('#button-recovery', this.container);
    this.btnTogglePassword = $('.btn-toggle', this.container);
    this.btnResend = $('#resendCode', this.container);

    this.modalLogin = $('#modal-login', this.container);
    this.modalRegister = $('#modal-register', this.container);
    this.modalRegisterSocial = $('#modal-register-social', this.container);
    this.modalRecovery = $('#modal-recovery', this.container);
    this.modalWelcome = $('#modal-welcome', this.container);
    this.modalCode = $('#modal-code', this.container);
    this.modalPassword = $('#modal-password', this.container);

    // login
    this.btnLogin.on('click', e => {
      e.preventDefault();

      this.modalRegister.addClass('hidden');
      this.modalRegisterSocial.addClass('hidden');
      this.modalRecovery.addClass('hidden');
      this.modalLogin.addClass('hidden');
      this.modalCode.addClass('hidden');
      this.modalPassword.addClass('hidden');

      this.modalWelcome.removeClass('hidden');
    });

    // login email
    this.btnLoginEmail.on('click', e => {
      e.preventDefault();

      this.modalRegisterSocial.addClass('hidden');
      this.modalRecovery.addClass('hidden');
      this.modalWelcome.addClass('hidden');
      this.modalCode.addClass('hidden');
      this.modalPassword.addClass('hidden');

      this.modalLogin.removeClass('hidden');
    });

    // back login
    this.modalLogin.find('.close').on('click', () => {
      this.modalLogin.addClass('hidden');

      this.modalWelcome.removeClass('hidden');
    });

    // register
    this.btnRegisterEmail.on('click', e => {
      e.preventDefault();

      this.modalLogin.addClass('hidden');
      this.modalRecovery.addClass('hidden');
      this.modalWelcome.addClass('hidden');
      this.modalRegisterSocial.addClass('hidden');
      this.modalCode.addClass('hidden');
      this.modalPassword.addClass('hidden');

      this.modalRegister.removeClass('hidden');
    });

    // back register
    this.modalRegister.find('.close').on('click', () => {
      this.modalRegister.addClass('hidden');

      this.modalRegisterSocial.removeClass('hidden');
    });

    // register social
    this.btnRegisterSocial.on('click', e => {
      e.preventDefault();

      this.modalLogin.addClass('hidden');
      this.modalRegister.addClass('hidden');
      this.modalRecovery.addClass('hidden');
      this.modalWelcome.addClass('hidden');
      this.modalCode.addClass('hidden');
      this.modalPassword.addClass('hidden');

      this.modalRegisterSocial.removeClass('hidden');
    });

    // recovery
    this.btnRecovery.on('click', e => {
      e.preventDefault();

      this.modalLogin.addClass('hidden');
      this.modalRegister.addClass('hidden');
      this.modalWelcome.addClass('hidden');
      this.modalCode.addClass('hidden');
      this.modalPassword.addClass('hidden');

      this.modalRecovery.removeClass('hidden');
    });

    // back recovery
    this.modalRecovery.find('.close').on('click', () => {
      this.modalRecovery.addClass('hidden');

      this.modalLogin.removeClass('hidden');
    });

    // back code
    this.modalCode.find('.close').on('click', () => {
      this.modalCode.addClass('hidden');

      this.modalRecovery.removeClass('hidden');
    });

    // back password
    this.modalPassword.find('.close').on('click', () => {
      this.modalPassword.addClass('hidden');

      this.modalCode.removeClass('hidden');
    });

    // toggle pass
    this.btnTogglePassword.on('click', () => {
      this.btnTogglePassword
        .parent()
        .find('#user_password')
        .attr(
          'type',
          this.btnTogglePassword
            .parent()
            .find('#user_password')
            .attr('type') === 'text'
            ? 'password'
            : 'text'
        );

      $('.q-icon-eye, .q-icon-eye-off').toggleClass(
        'q-icon-eye-off q-icon-eye'
      );
    });

    // form validator
    validator.init();
    new FormSubmitToggle('#registration_form', true);
    new SignupEmailAssist('#registration_form');

    this.recoveryFormValidation();
    this.codeFormValidation();
    this.passwordFormValidation();
    this.trackingGTM();

    // regressive
    this.btnResend.on('click', () => {
      $('#formRecoveryPassword').submit();
      this.btnResend.attr('disabled', 'disabled');
      this.regressive(900); // 15 minutos
    });
  }

  trackingGTM() {
    // login
    const $formLogin = $('#login_form');

    $formLogin.on('submit', e => {
      e.stopPropagation();

      window['dataLayer'].push({
        event: 'login',
        method: 'Formulário'
      });
    });

    // register
    const $formRegister = $('#registration_form');
    let registered = false;

    if (!registered) {
      $formRegister.on('submit', e => {
        e.stopPropagation();

        registered = true; // avoid triggering multiple events

        zaraz.track('User Registered', {
          method: 'Email',
          location_id: 'conta cadastrar'
        });

        window['dataLayer'].push({
          event: 'sign_up',
          method: 'Formulário',
          is_checkout: false
        });
      });
    }

    // social
    const $btnSocial = $('.btn-open-auth');

    $btnSocial.on('click', () => {
      window['dataLayer'].push({
        event: !$btnSocial.parents('#modal-welcome').hasClass('hidden')
          ? 'login'
          : 'sign_up',
        method: 'Social'
      });
    });
  }

  async getToken() {
    const response = await $.post({
      url: '/oauth/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: {
        ...credentials[window.RAILS_ENV],
        grant_type: 'client_credentials'
      }
    });

    return response?.access_token;
  }

  recoveryFormValidation() {
    this.$formRecovery = $('#formRecoveryPassword', this.container);

    this.modalRecovery = $('#modal-recovery', this.container);
    this.modalCode = $('#modal-code', this.container);

    this.$formRecovery.on('submit', async e => {
      e.preventDefault();

      const textButton = $(this.$formRecovery.find('[type=submit]')[0])
        .text()
        .trim();

      $(this.$formRecovery.find('[type=submit]')[0])
        .html('Aguarde...')
        .attr('disabled', 'disabled');

      const token = await this.getToken();

      if (token) {
        const { user } = this.$formRecovery.serializeObject();

        $.ajax({
          url: '/api/auth/users/reset_passwords/start',
          method: 'POST',
          dataType: 'json',
          data: {
            email: user.email
          },
          headers: {
            Authorization: `Bearer ${token}`
          },
          success: () => {
            this.email = user.email;

            this.modalCode.removeClass('hidden');
            this.modalRecovery.addClass('hidden');

            // regressive counter
            this.regressive(900); // 15 minutos

            // tracking
            UserTracker.emit('event', {
              eventName: 'new password email submitted',
              data: {
                request_path: window.location.pathname,
                code_validation_status: 200
              }
            });
          },
          complete: () => {
            $(this.$formRecovery.find('[type=submit]')[0])
              .html(textButton)
              .removeAttr('disabled');
          },
          error: () => {
            validator.validate.showError(
              this.$formCode.find('#code')[0],
              'E-mail inválido ou não existe'
            );

            // tracking
            UserTracker.emit('event', {
              eventName: 'new password email submitted',
              data: {
                request_path: window.location.pathname,
                code_validation_status: 500
              }
            });
          }
        });
      }
    });
  }

  codeFormValidation() {
    this.$formCode = $('#formCode', this.container);

    this.modalCode = $('#modal-code', this.container);
    this.modalPassword = $('#modal-password', this.container);

    this.$formCode.on('submit', async e => {
      e.preventDefault();

      const textButton = $(this.$formCode.find('[type=submit]')[0])
        .text()
        .trim();

      $(this.$formCode.find('[type=submit]')[0])
        .html('Aguarde...')
        .attr('disabled', 'disabled');

      const token = await this.getToken();

      if (token) {
        const { code } = this.$formCode.serializeObject();

        $.ajax({
          url: '/api/auth/users/reset_passwords/check',
          method: 'POST',
          dataType: 'json',
          data: {
            code,
            email: this.email
          },
          headers: {
            Authorization: `Bearer ${token}`
          },
          success: response => {
            this.modalCode.addClass('hidden');
            this.modalPassword.removeClass('hidden');

            // tracking
            UserTracker.emit('event', {
              eventName: 'new password code submitted',
              data: {
                request_path: window.location.pathname,
                code_validation_status: 200,
                code_validation_message: JSON.stringify(response)
              }
            });
          },
          complete: () => {
            $(this.$formCode.find('[type=submit]')[0])
              .html(textButton)
              .removeAttr('disabled');
          },
          error: error => {
            validator.validate.showError(
              this.$formCode.find('#code')[0],
              'Código expirado ou inválido'
            );

            // tracking
            UserTracker.emit('event', {
              eventName: 'new password code submitted',
              data: {
                request_path: window.location.pathname,
                code_validation_status: 500,
                code_validation_message: JSON.stringify(error.responseJSON)
              }
            });
          }
        });
      }
    });
  }

  passwordFormValidation() {
    this.$formPassword = $('#formPassword', this.container);

    this.modalPassword = $('#modal-password', this.container);
    this.modalLogin = $('#modal-login', this.container);

    this.$formPassword.on('submit', async e => {
      e.preventDefault();

      const textButton = $(this.$formPassword.find('[type=submit]')[0])
        .text()
        .trim();

      $(this.$formPassword.find('[type=submit]')[0])
        .html('Aguarde...')
        .attr('disabled', 'disabled');

      const token = await this.getToken();

      if (token) {
        const { user } = this.$formPassword.serializeObject();

        $.ajax({
          url: '/api/auth/users/reset_passwords/confirm',
          method: 'POST',
          dataType: 'json',
          data: {
            email: this.email,
            password: user.password
          },
          headers: {
            Authorization: `Bearer ${token}`
          },
          success: () => {
            this.modalPassword.addClass('hidden');
            this.modalLogin.removeClass('hidden');

            this.email = null;
          },
          complete: () => {
            $(this.$formPassword.find('[type=submit]')[0])
              .html(textButton)
              .removeAttr('disabled');
          },
          error: () =>
            validator.validate.showError(
              this.$formCode.find('#code')[0],
              'Senha inválida'
            )
        });
      }
    });
  }

  regressive(timeRemaining) {
    const $counter = $('#countTimer', this.container);
    const $buttonResend = $('#resendCode', this.container);

    $counter.html(`Você poderá reenviar o código em <strong>${this.formatTime(timeRemaining)}</strong>`);

    let initialTime = timeRemaining;
    let seconds;

    seconds = setInterval(() => {
      initialTime--;
      $counter.html(`Você poderá reenviar o código em <strong>${this.formatTime(initialTime)}</strong>`);

      if (initialTime <= 0) {
        clearInterval(seconds);
        $counter.text('Você pode reenviar o código agora');
        $buttonResend.removeAttr('disabled');
      }
    }, 1000);
  }

  formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');
    return `${mm}:${ss}`;
  }

  static requestCode(
    email,
    token,
    callbackSuccess,
    callbackEnd,
    callbackError
  ) {
    $.ajax({
      url: '/api/auth/users/reset_passwords/start',
      method: 'POST',
      dataType: 'json',
      data: {
        email
      },
      headers: {
        Authorization: `Bearer ${token}`
      },
      success: callbackSuccess,
      complete: callbackEnd,
      error: callbackError
    });
  }
}

export default class LoginRegister {
  static newLoginModal(return_url, data = {}) {
    AjaxComponentLoader.load({
      component: 'modals/login_register_modal',
      type: 'component',
      data: {
        return_url,
        ...data
      }
    })
      .then(html => {
        const $loginContainer = $('#js-login-register-modal');

        if ($loginContainer.length > 0) {
          $loginContainer.remove();
        }

        $('body').append(html);
        const modal = (window?.ModalManager ?? ModalManager).open(
          '#js-login-register-modal'
        );
        new LoginRegisterModal(
          modal,
          $('#js-login-register-modal').hasClass('q-auth-modal')
        );

        // tracking events
        if ($(modal)?.data?.('trackingEvent')) {
          UserTracker.emit('event', {
            eventName: 'account create paywall opened',
            data: {
              request_path: return_url
            }
          });
        }

        if (data.trackingEvent) {
          UserTracker.emit('event', data.trackingEvent);
        }
      })
      .catch(() => {
        if (window?.Turbolinks) {
          Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        } else {
          window.location.href = `/conta/entrar?return_url=${return_url}`;
        }
      });
  }
}
